export default __webpack_public_path__ + "static/media/QueIcon.bc1e1abc.svg";